import Vue from 'vue'
import VueRouter from 'vue-router'
import Submission from '@/views/Submission.vue'
import Terms from '@/views/Terms.vue'
import DealsPage from '@/views/Deals.vue'
import ArchivedDeals from '@/views/ArchivedDeals.vue'
import SelectedDeals from '@/views/SelectedDeals.vue'
import ProfilePage from '@/views/Profile.vue'
import ResetPassword from '@/views/Recovery'
import HealthcareInvestor from '@/views/sectors/HealthcareInvestor'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'submission',
    component: Submission
  },
  {
    path: '/terms',
    name: 'terms',
    component: Terms
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPassword
  },
  {
    path: '/deals',
    name: 'deals',
    component: DealsPage
  },
  {
    path: '/deals/archived',
    name: 'deals',
    component: ArchivedDeals
  },
  {
    path: '/sectors/healthcare/investor',
    name: 'healthcare-investor',
    component: HealthcareInvestor
  },
  {
    path: '/my-deals',
    name: 'my-deals',
    component: SelectedDeals
  },
  {
    path: '/edit-profile',
    name: 'edit-profile',
    component: ProfilePage
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to) => {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth'
      }
    }
    return { x: 0, y: 0 }
  }

})

export default router
